import angular from 'angular'

import { values, uniqueId } from 'lodash-es'

angular
  .module('ggs.gallery-styler-new')
  .factory('GSNInspectManager', GSNInspectManagerProvider)

function GSNInspectManagerProvider(DefineMethod) {

  return function GSNInspectManager(properties) {
    const clients = {}
    const listeners = {}

    const sign = 'GSNInspectManager'
    const inspector = ({ wrapM: DefineMethod(sign) })

    inspector
      .wrapM('init', init)
      .wrapM('destroy', destroy)
      .wrapM('delta', delta)

    return inspector

    function init() {
      properties.keys.forEach((propKey) => {
        const emitter = properties.key2emitter[propKey]
        const listener = () => values(clients).forEach((clientInfo) => clientInfo.propKeys.push(propKey))
        emitter.after(listener)
        listeners[propKey] = listener
      })
    }

    function destroy() {
      properties.keys.forEach((propKey) => {
        const emitter = properties.key2emitter[propKey]
        const listener = listeners[propKey]
        emitter.off(listener)
      })
    }

    function delta(clientId, lastDeltaId) {
      const resetupClient = false
        || !clients.hasOwnProperty(clientId)
        || (clients[clientId].lastDeltaId !== lastDeltaId)

      if (resetupClient) {
        clients[clientId] = {
          propKeys: properties.keys,
          lastDeltaId
        }
      }

      const clientInfo = clients[clientId]
      const deltaId = uniqueId()
      const delta = clientInfo.propKeys.map((propKey) => ({
        style: propKey,
        value: properties.get(propKey)
      }))

      clientInfo.propKeys = []
      clientInfo.lastDeltaId = deltaId

      return { delta, deltaId, clientId }
    }
  }
}
